// Components==============
import indexCourses from 'actions/training/training/index';
import FilterMenu from 'components/Layout/FilterMenu/FilterMenu';
import Layout from 'components/Layout/Layout';
import Container from 'components/UI/Container/Container';
import NoContent from 'components/UI/NoContent/NoContent';
import Title from 'components/UI/Title/Title';
import TrainingCard from 'components/UI/TrainingCard/TrainingCard';
import { useFilter } from 'hooks/useFilter';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useEffect } from 'react';
import {
  categoryFilter,
  publicationFilter,
  reduceFilter,
  searchFilter,
} from 'utilities/filters';
import './Courses.module.scss';
// =========================

export default function Courses() {
  const dispatch = useReduxAction();

  const userOrganisation = useRedux(
    (state) => state.authentication?.user.organisation.name || ''
  );

  useEffect(() => {
    dispatch(indexCourses());
  }, []);

  // Filter logic
  const { filterValues, setFilterValues, initial } = useFilter('courses');

  const f1 = searchFilter(filterValues[0].value as string, 'title');
  const f2 = categoryFilter(filterValues[1].value as number[]);
  const f3 = publicationFilter(
    filterValues[2].value as string,
    userOrganisation
  );

  const courses = useRedux((state) => {
    const data = state.training?.entities.allIds
      .map((id) => state.training?.entities.byId[id])
      .filter((training) => training?.visibility !== 'private')
      .reverse();

    return reduceFilter([f1, f2, f3], data);
  });
  //

  const loading = useRedux(
    (state) => state.training?.loading || state.skill?.loading
  );

  return (
    <Layout
      filter={
        <FilterMenu
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          initial={initial}
        />
      }
    >
      <NoContent
        page="courses"
        loading={!!loading}
        hasContent={courses ? courses?.length > 0 : false}
      >
        <Container>
          <Title text="general.terms.courses" loading={loading} />
          <div styleName="wrapper">
            {courses?.map((course) => (
              <TrainingCard
                key={course?.id}
                training={course}
                withModal
                inLibrary
              />
            ))}
          </div>
        </Container>
      </NoContent>
    </Layout>
  );
}
